// ./app/providers.tsx

'use client';

import React from 'react';
import { SessionProvider } from 'next-auth/react';

// import { GlobalStateProvider } from '#/providers/GlobalStateContext';
import UserContextProvider from '#/providers/UserContext';
import WagmiProvider from '#/providers/W3Provider';

const RootProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <div>
      {/* <GlobalStateProvider> */}
      <SessionProvider>
        <UserContextProvider>
          <WagmiProvider>{children}</WagmiProvider>
        </UserContextProvider>
      </SessionProvider>
      {/* </GlobalStateProvider> */}
    </div>
  );
};

// Exports
// ========================================================
export default RootProvider;
